import { TCollectionFormatted } from '@/types/collection'

/**
 * Parse filters from URLSearchParams to object
 */

export const parseFiltersFromSearchParams = (searchParams: URLSearchParams) => {
  const initial: Record<string, string | string[]> = {}
  searchParams.forEach((value, key) => {
    initial[key] = value.includes(',') ? value.split(',') : value
  })
  return initial
}
/**
 * Build URLSearchParams from filters object
 */
export const buildFilterParams = (
  filters: { [key: string]: string[] | string | undefined },
  searchParams: URLSearchParams
): URLSearchParams => {
  const params = new URLSearchParams(searchParams)
  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        params.set(key, value.join(','))
      } else {
        params.delete(key)
      }
    } else {
      if (value) {
        params.set(key, value.toString())
      } else {
        params.delete(key)
      }
    }
  })
  return params
}

/**
 * Lấy giá trị filter dạng string (ưu tiên cho radio, color, ...)
 */
export const getFilterValue = (
  key: string,
  filter: Record<string, string | string[] | undefined>
): string | undefined => {
  const val = filter[key]
  return typeof val === 'string' ? val : undefined
}

/**
 * Lấy giá trị filter dạng array (ưu tiên cho checkbox, multi-select)
 */
export const getFilterValues = (
  key: string,
  filter: Record<string, string | string[] | undefined>
): string[] => {
  const val = filter[key]
  if (!val) return []
  return Array.isArray(val) ? val : [val.toString()]
}

import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

interface UpdateUrlOptions {
  scroll?: boolean
  shallow?: boolean
}

export const updateUrl = (
  url: string,
  options?: UpdateUrlOptions,
  router?: AppRouterInstance
) => {
  if (router) {
    router.replace(url, { scroll: options?.scroll ?? true })
  } else {
    // Fallback cho trường hợp không có router (ví dụ: trong tests)
    window.history.pushState({}, '', url)
    if (options?.scroll === false) {
      window.scrollTo(0, window.scrollY)
    }
  }
}

// Lấy danh sách key filter hợp lệ từ collection
export function getValidFilterKeys(collection: TCollectionFormatted): string[] {
  const normalAttributes = collection.filter?.normalAttributes || []
  const attributeCards = collection.filter?.attributeCards || []
  return [
    'size',
    'color',
    'price',
    'price_range',
    'kieu-dang-quan-lot',
    'gender_type',
    ...normalAttributes.map((attribute) => attribute.seo_alias),
    ...attributeCards.map((card) => card.seo_alias),
  ]
}

// Trả về trạng thái filter: có filter không và số lượng filter đang active
export function getFilterStatus(
  filter: Record<string, string | string[] | undefined>,
  collection: TCollectionFormatted
) {
  const filterValid = getValidFilterKeys(collection)
  let count = 0
  let hasActiveFilter = false

  for (const key of Object.keys(filter)) {
    if (filterValid.includes(key)) {
      hasActiveFilter = true
      count++
    }
  }

  return {
    hasFilter: hasActiveFilter,
    filterCount: count,
  }
}

/** Parse filters from URLSearchParams */
